import { render, staticRenderFns } from "./startupRequest.vue?vue&type=template&id=655eb474&scoped=true"
import script from "./startupRequest.vue?vue&type=script&lang=js"
export * from "./startupRequest.vue?vue&type=script&lang=js"
import style0 from "./startupRequest.vue?vue&type=style&index=0&id=655eb474&prod&scoped=true&lang=css"
import style1 from "./startupRequest.vue?vue&type=style&index=1&id=655eb474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655eb474",
  null
  
)

export default component.exports